import call from './httpClient';

const BASE_URL = `${import.meta.env.VITE_APP_API_URL}/v1/baskets`;
export const Add = async ({ data }) => call({
  data,
  method: 'PUT',
  url: BASE_URL,
});

export const Get = async () => call({
  method: 'GET',
  url: BASE_URL,
});

export const Remove = async (id) => call({
  method: 'DELETE',
  url: `${BASE_URL}/${id}`,
});
